import React from "react";
import Container from "./components/Container";
import Header from "./components/Header";
import Section from "./components/Section";
import PublicationCard from "./components/PublicationCard";
import { siteData } from "./data/siteData";

export default function App() {
  const { profile, socialLinks, publications, teaching, academicService } = siteData;

  return (
    <main className="min-h-screen bg-white text-black">
      <Container>
        <Header profile={profile} socialLinks={socialLinks} />

        <Section title="Selected Publications">
          <div className="space-y-4">
            {publications.map((publication) => (
              <PublicationCard
                key={publication.id}
                publication={publication}
              />
            ))}
          </div>
        </Section>

        <Section title="Teaching & Academic Service">
          <div className="space-y-3 text-sm leading-6 text-black sm:text-base">
            {teaching.map((position) => (
              <div key={position.id}>
                <p>
                  <span className="font-medium">{position.role}</span>,{" "}
                  <a
                    href={position.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 transition-colors hover:text-orange-500"
                  >
                    {position.course}
                  </a>{" "}
                  — {position.institution}, {position.term}
                </p>
                <p className="mt-1 text-sm">
                  Instructors:{" "}
                  {position.instructors.map((instructor, index) => (
                    <React.Fragment key={instructor.href}>
                      {index > 0 && " and "}
                      <a
                        href={instructor.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 transition-colors hover:text-orange-500"
                      >
                        {instructor.name}
                      </a>
                    </React.Fragment>
                  ))}
                </p>
              </div>
            ))}
            {academicService.map((service) => (
              <p key={service.role}>
                <span className="font-medium">{service.role}</span>,{" "}
                {service.venues.map((venue) => `${venue.name} ${venue.year}`).join(", ")}
              </p>
            ))}
          </div>
        </Section>
      </Container>
    </main>
  );
}
